import React from "react";
import "./PriceDetail.css";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import * as actions from "../../Store/Actions/index";
const PriceDetail = (props) => {
  if (props.route.match.path === "/cart/shipping/ordersummary") {
  }
  let total = 0;
  let shippingCharge = 450;
  let shipping = 0;
  let totalQuantity = 0;
  props.cartBook.map((book, index) => {
    total += Number(book.totalBookPrice);
    if (props.country) {
      totalQuantity += book.quantity
      shipping = total + (shippingCharge * totalQuantity);
      props.shippingChargeHandler(shipping);
    }
  });

  let shippingContainer;
  shippingContainer =
    props.route.history.location.pathname === "/cart/shipping" &&
    props.country ? (
     <div>
        <div className="field-container cart-value">
        <div className="field-name">Shipping Charges <span>(per book)</span></div>
        <div className="field-name">₹ {shippingCharge}</div>
        
      </div>
       {/* <div className="field-container cart-value">
       <div className="field-name"> Total Shipping Charges</div>
       <div className="field-name">₹ {shippingCharge*totalQuantity}</div>
       
     </div> */}
     </div>
    ) : 
    (
      <div>
      <div className="field-container cart-value">
        <div className="field-name">
          Shipping Charges
        </div>
        <div className="field-name">₹ 0</div>
      </div>
    </div>
    );
  return (
    <div>
      <div className="content-container">
        <div className="inner-div">
          <div className="field-container cart-value">
            <div className="field-name">Cart Value</div>
            <div className="field-name">₹ {total}</div>
          </div>
          {shippingContainer}
          <div className="field-container cart-value">
            <div className="field-name">Total Cart Value </div>
            <div className="field-name">
              ₹ {props.country ? shipping : total}
            </div>
          </div>
        </div>
      </div>
      {props.cartBook.length > 0 ? (
        props.route.match.path === "/cart/shipping" ? (
          // <NavLink to="/ordersummary"  >
          <div className="checkout checkoutQuery" onClick={props.clicked}>
            <button> Confirm Checkout </button>
            <p className = "shippingDetailCharge">
            {/* 450/per book will be charged,if outside india.  */}
            International Shipping Not allowed 
          </p>
          </div>
        ) : (
          // </NavLink>
          <NavLink to="/cart/shipping">
            <div className="checkout">
              <button> Proceed to Checkout </button>
            </div>
          </NavLink>
        
        )
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    address: state.book.address,
    addedBooks: state.book.addedBooks,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    shippingChargeHandler: (shippingCharge) =>
      dispatch(actions.checkout(shippingCharge)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceDetail);
